export default "__VITE_ASSET__CwB1frzW__"